import React from 'react'
import { Button } from '@mui/material'
import AsynchronousActionButton from './AsynchronousActionButton'

export function ContinueButton({ 
    onClick, 
    disabled = false, 
    text = "Continue",
    loading = false,
    bold = false,
}) {
    return (
        <Button
            onClick={onClick}
            disabled={disabled || loading}
            sx={{
                position: 'fixed',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                bottom: '48px',
                backgroundColor:'#1F477D',
                color: '#FFFFFF',
                padding: '13px 28px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: bold ? 600 : 500,
                lineHeight: '24px',
                textTransform: 'none',
                minWidth: '375px',
                width: 'clamp(280px, 375px, calc(100vw - 32px))',
                '@media (max-width: 768px)': {
                    width: 'calc(100vw - 32px)',
                    left: '16px',
                    transform: 'none',
                    minWidth: 'unset',
                    maxWidth: '375px',
                    margin: '0 auto',
                    right: '16px',
                },
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                '&:hover': {
                    backgroundColor: disabled ? '#9CA3AF' : '#1a3a66',
                },
                '&:disabled': {
                    backgroundColor: '#E5E7EB',
                    color: '#6B7280',
                },
            }}
        >
            {loading ? 'Processing...' : text}
        </Button>
    )
}

export function AsynchronousContinueButton({
    onClick,
    disabled = false,
    text = "Continue",
    loading = false,
    success = false,
    setSuccess = () => {},
    setLoading = () => {},
    sx = {},
}) {
    return (
        <AsynchronousActionButton
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            success={success}
            setSuccess={setSuccess}
            setLoading={setLoading}
            sx={{
                ...sx,
                position: 'fixed',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                bottom: '48px',
                backgroundColor:'#1F477D',
                color: '#FFFFFF',
                padding: '13px 28px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 500,
                lineHeight: '24px',
                textTransform: 'none',
                minWidth: '375px',
                width: 'clamp(280px, 375px, calc(100vw - 32px))',
                '@media (max-width: 768px)': {
                    width: 'calc(100vw - 32px)',
                    left: '16px',
                    transform: 'none',
                    minWidth: 'unset',
                    maxWidth: '375px',
                    margin: '0 auto',
                    right: '16px',
                },
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                '&:hover': {
                    backgroundColor: disabled ? '#9CA3AF' : '#1a3a66',
                },
                '&:disabled': {
                    backgroundColor: '#E5E7EB',
                    color: '#6B7280',
                },
            }}
        >
            {loading ? "" : text}
        </AsynchronousActionButton>
    )
}
